import React from 'react';

export default function StyleOverrider(DefaultComponent) {
    let CurrentComponent = DefaultComponent;

    const Component = props => <CurrentComponent {...props} />;

    const setComponentStyle = ComponentParam => CurrentComponent = ComponentParam;

    return [Component, setComponentStyle];
}
